// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"fad12268","96":"026ef1e4"}[chunkId] + ".css";
};